<template>
    <div class="col-12 mb-primary">
        <h3 class="card-title d-inline-block mb-2">{{ $t('assignment_instruction') }}</h3>
        <!-- <div class="float-right">
            how do other people see your profile? <a href="companyprofile/view" class="btn btn-primary btn-sm">View As</a>
        </div> -->
        <app-table
            :id="tableId"
            :options="options"
            :mydata="tabledata"
            @action="getListAction"
        />
    </div>

</template>

<script>
import CoreLibrary from "../../../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../../Config/ApiUrl";
import {TableHelpers} from '../../../../Demo/Tables/mixins/TableHelpers';
import AppFunction from "../../../../../../../core/helpers/app/AppFunction";


export default {
    extends: CoreLibrary,
    name: "DatatableWithFilter",
    mixins: [TableHelpers],
    data() {
        return {
                    tabledata:[
                            { 
                                
                        0:{
                            date:'10-oct-2021',
                            package_name:'No 464580',
                            duration:'6 Month',
                            amount:'$50',
                        },
                        1:{
                            date:'11-oct-2021',
                            package_name:'No 464581',
                            duration:'7 Month',
                            amount:'$60',
                        },
                        2:{
                            date:'12-oct-2021',
                            package_name:'No 464582',
                            duration:'8 Month',
                            amount:'$70',
                        },
                    }

                    // {
                    // "data": [
                    //     {
                    //     "date": '7-april-2021',
                    //     "InvoiceNumber": "No24372389",
                    //     "Recipient": "Fyodor Dostoevsky"
                    //     },
                    //     {
                    //     "date": '7-april-2021',
                    //     "InvoiceNumber": "No24372389",
                    //     "Recipient": "Fyodor Dostoevsky"
                    //     },
                    //     {
                    //     "date": '7-april-2021',
                    //     "InvoiceNumber": "No24372389",
                    //     "Recipient": "Fyodor Dostoevsky"
                    //     }
                    // ]
                    // }

                ],
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: '',
            rowData: {},
            options: {
                name: 'AdvanceTable',
                url: actions.DATATABLE_DATA,
                showHeader: true,
                columns: [
                        {
                            title: this.$t('sno'),
                            type: 'media-object',
                            key: 'media-object',
                            mediaTitleKey: 'id',
                            modifier: (value, row) => {
                                // return value; // imag url
                            },
                            isVisible: true
                        },
                        {
                            title: this.$t('name'),
                            type: 'custom-html',
                            key: 'name',
                            modifier: (value) => {
                                return `<span>${this.$t(value)}</span>`
                            }
                        },
                        {
                            title: this.$t('package_name'),
                            type: 'custom-html',
                            key: 'status',
                            isVisible: true,
                            modifier: (value) => {
                                let ClassName = 'danger';

                                if (value === 'active') ClassName = `success`;
                                else if (value === 'invited') ClassName = `warning`;

                                return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(value)}</span>`;
                            }
                        },
                        {
                            title: this.$t('duration'),
                            type: 'custom-html',
                            key: 'date',
                            modifier: (value) => {
                                return `<span>${this.$t(value)}</span>`
                            }
                        },
                        {
                            title: this.$t('amount'),
                            type: 'custom-html',
                            key: 'gender',
                            modifier: (value) => {
                                return `<span>${this.$t(value)}</span>`
                            }
                        },
                    ],
                actions: [],
                filters: [
                    {
                        "title": this.$t('date'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "last7Days", "nextYear"]
                    },
                    {
                        "title": this.$t('age'),
                        "type": "range-filter",
                        "key": "age-range",
                        "maxTitle": this.$t('max_age'),
                        "minTitle": this.$t('min_age'),
                        "sign": ""
                    },
                    {
                        "title": this.$t('status'),
                        "type": "checkbox",
                        "key": "status",
                        "option": [
                            {id: 'active', value: 'Active'},
                            {id: 'inactive', value: 'Inactive'},
                            {id: 'invited', value: 'Invited'},
                        ],
                    },
                    {
                        "title": this.$t('gender'),
                        "type": "radio",
                        "key": "filter-with-gender",
                        "option": [
                            {id: 'male', value: 'Male'},
                            {id: 'female', value: 'Female'},
                            {id: 'other', value: 'Other'},
                        ],
                        "header": {
                            "title": this.$t('want_to_filter_your_list'),
                            "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
                        },
                    },
                    {
                        "title": this.$t('search_and_select'),
                        "type": "drop-down-filter",
                        "key": "search select",
                        "option": [],
                    }
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                // showAction: true,
                orderBy: 'desc',
                // actionType: "default",
            }
        }
    },
    created() {
        this.options.columns = [...this.options.columns];
        this.searchAndSelectFilterOptions();
    },
    methods: {
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal
         */
        closeAddEditModal() {
            $("#demo-add-edit-Modal").modal('hide');
            this.isAddEditModalActive = false;
            this.searchAndSelectFilterOptions();
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;

            if (actionObj.title == 'Delete') {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.DATATABLE_DATA}/${rowData.id}`;
                this.openAddEditModal();
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.DATATABLE_DATA}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                    this.searchAndSelectFilterOptions();
                }).catch(({error}) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
        searchAndSelectFilterOptions() {
            this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then(response => {
                let name = this.options.filters.find(element => element.title === this.$t('search_and_select'));

                name.option = response.data.map(name => {
                    return {
                        id: name.name,
                        value: name.name
                    }
                });
            });
        }
    },
}
</script>